import * as React from 'react';
import { Component, Fragment } from 'react';
import { action, observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Icon from './Icon';
import DownloadControls from './DownloadControls';
import Badge from './Badge';

const DropDownWrapper = styled<any, any>('div')`
    ${propStyles};
`;

DropDownWrapper.defaultProps = {
    display: 'inline-flex',
};

const DocumentTitle = styled<any, any>('button')`
    ${propStyles};
    outline: none;
    cursor: pointer;
`;

DocumentTitle.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: '1 0 0%',
    fontSize: 'inherit',
    fontFamily: 'inherit',
    fontWeight: 'inherit',
    textAlign: 'right',
    bgColor: 'transparent',
    borderStyle: 'none',
};

const DocumentTitleControls = styled<any, any>('div')`
    ${propStyles};
`;

DocumentTitleControls.defaultProps = {
    display: 'flex',
    alignItems: 'center',
};

const DocumentList = styled<any, any>('ul')`
    ${propStyles};
`;

DocumentList.defaultProps = {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 100%',
    flexWrap: 'wrap',
    margin: '1em 0 0 0',
};

const DocumentListItem = styled<any, any>('li')`
    ${propStyles};
`;

DocumentListItem.defaultProps = {
    display: 'flex',
    flex: '1 0 auto',
    alignItems: 'center',
    paddingX: 'xs',
    paddingY: 'sm',
    margin: '0 2px',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'none none solid none',
    hover: {
        bgColor: 'gray100',
    },
};

@inject('dataStore')
@observer
class DocumentMenu extends Component<any, any> {
    @observable open = false;

    @action
    toggleDropdown = () => {
        this.open = !this.open;
    };

    render() {
        const { theme, dataStore, children, documents = [] } = this.props;

        return (
            <Fragment>
                <DocumentTitle
                    onClick={e => {
                        e.stopPropagation();
                        this.toggleDropdown();
                    }}
                >
                    {children}
                    <DocumentTitleControls>
                        <Badge bgColor="primary">{documents.length}</Badge>
                        <Icon
                            fileName={
                                this.open
                                    ? 'DocumentDropdownIconExpanded'
                                    : 'DocumentDropdownIcon'
                            }
                            height="1.4em"
                            width="1.4em"
                            {...theme.DocumentMenuIcon}
                        />
                    </DocumentTitleControls>
                </DocumentTitle>
                {this.open && (
                    <DocumentList {...theme.DocumentList}>
                        {documents.map((document, index) => (
                            <DocumentListItem
                                key={document.clientCode}
                                {...theme.DocumentListItem}
                            >
                                <DownloadControls
                                    label={dataStore.getDocumentDisplayName(
                                        document
                                    )}
                                    onClick={() =>
                                        dataStore.downloadDocuments([document])
                                    }
                                    showCount={false}
                                    flex="1 1 auto"
                                    theme={{
                                        ...theme,
                                        ...{
                                            DownloadButton: {
                                                flex: '1 1 auto',
                                                flexDirection: 'row-reverse',
                                                justifyContent: 'flex-end',
                                            },
                                        },
                                    }}
                                    isMobile={dataStore.isMobile}
                                />
                            </DocumentListItem>
                        ))}
                    </DocumentList>
                )}
            </Fragment>
        );
    }
}

export default withTheme(DocumentMenu) as any;



// WEBPACK FOOTER //
// ./src/Components/DocumentMenu.tsx